import exporter from './search/exporter'
import importer from './search/importer'
import product from './search/product'
import Vue from 'vue'
import _ from 'lodash'

const state = {
  activeName: 'rate',
  isShowChris: true,
  history: {
    exporter: [],
    importer: [],
    products: [],
    all: []
  }
}

const localState = {
  historyData: {}
}

const getters = {}

const mutations = {
  setChrisState (state, value) {
    state.isShowChris = value
  },
  updateState (state, value) {
    state.activeName = value
    this.commit('data/setCurrentProduct', true)
    this.dispatch('search/asyncHistoryData', true)
  },
  updateHistory (state, value) {
    this.dispatch('search/asyncHistoryData', value)
  },
  loadHistory (state, value) {
    let his = Vue._h.storage.local.get('shq') || {}
    let new_his = Vue._h.storage.local.get('new_shq') || {}
    if (!_.isEmpty(his)) {
      if (his['exporter'] || his['importer'] || his['products']) {
        Vue._h.storage.local.remove('shq')
      } else {
        localState.historyData = his
        if (_.isEmpty(new_his)) {
          this.dispatch('search/asyncHistoryData', true)
        }
      }
    }
    if (!_.isEmpty(new_his)) {
      state.history = new_his
    }
  },
  setHistoryData (state, item) {
    if (item.value.exporter && item.value.exporter.id) {
      state.history.exporter = _.slice(_.filter(_.uniqBy([item.value.exporter].concat(state.history.exporter), 'id'), (o) => {
        return !_.isEmpty(_.trim(o.id)) && !_.isEmpty(_.trim(o.text))
      }), 0, 20)
    }
    if (item.value.importer && item.value.importer.id) {
      state.history.importer = _.slice(_.filter(_.uniqBy([item.value.importer].concat(state.history.importer), 'id'), (o) => {
        return !_.isEmpty(_.trim(o.id)) && !_.isEmpty(_.trim(o.text))
      }), 0, 20)
    }
    if (item.value.products && item.value.products.id) {
      state.history.products = _.slice(_.filter(_.uniqBy([item.value.products].concat(state.history.products), 'id'), (o) => {
        return !_.isEmpty(_.trim(o.id)) && !_.isEmpty(_.trim(o.text))
      }), 0, 20)
    }
    state.history.all = _.slice(_.filter(_.uniqWith([item.value].concat(state.history.all), _.isEqual), (o) => {
      return o && o.exporter && o.importer && !_.isEmpty(_.trim(o.exporter.id)) && !_.isEmpty(_.trim(o.importer.id)) && !_.isEmpty(_.trim(o.products.id)) && !_.isEmpty(_.trim(o.exporter.text)) && !_.isEmpty(_.trim(o.importer.text)) && !_.isEmpty(_.trim(o.products.text))
    }), 0, 20)
    localState.historyData[item.impoterID] = state.history
    Vue._h.storage.local.set('shq', localState.historyData)
    Vue._h.storage.local.set('new_shq', state.history)
  },
  setCurrentHistory (state, importerID) {
    let importerAll = this.getters['data/getImporterAll']
    if (!importerAll || importerAll.length <= 1) return
    if (!importerID) {
      let currentImporter = this.getters['search/importer/getRelValue']
      if (currentImporter && currentImporter.id) {
        importerID = currentImporter.id
      }
    }
    if (importerID && importerID in localState.historyData) {
      state.history = localState.historyData[importerID]
    } else {
      state.history = {
        exporter: [],
        importer: [],
        products: [],
        all: []
      }
    }
  }
}

const actions = {
  asyncHistoryData ({ commit, state, rootState, rootGetters }, value) {
    let currentImporter = rootGetters['search/importer/getRelValue']
    if (!currentImporter || !currentImporter.id) {
      currentImporter = rootState.data.importerPlaceholder
    }
    if (currentImporter && currentImporter.id) {
      if (value === true) {
        commit('setCurrentHistory', currentImporter.id)
      } else {
        commit('setHistoryData', {
          impoterID: currentImporter.id,
          value: value
        })
      }
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules: {
    exporter,
    importer,
    product
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/search.js